import axios from 'axios'
/**
 * 获取当前账号已创建的用户列表
 * @param {String} pageSize 每页条数
 * @param {Stirng} pageNo  当前页码
 * @param {Stirng} username  登录名
 * @param {Stirng} locked 是否锁定
 */
export const getMyUserList = async (options) => {
  const { data: { recordCount, records } } = await axios.get(`v1/users/external?pageSize=${options.pageSize}&pageNo=${options.pageNo}&username=${options.username}`)
  return { recordCount, records }
}

/**
 * 天盈 不显示锁定用户
 * @param {String} pageSize 每页条数
 * @param {Stirng} pageNo  当前页码
 * @param {Stirng} username  登录名
 * @param {Stirng} locked 是否锁定
 */
export const getMyUserListUnlock = async (options) => {
  const { data: { recordCount, records } } = await axios.get(`v1/users/external?pageSize=${options.pageSize}&pageNo=${options.pageNo}&username=${options.username}&locked=false`)
  return { recordCount, records }
}

/**
 * 天盈 只显示锁定用户
 * @param {String} pageSize 每页条数
 * @param {Stirng} pageNo  当前页码
 * @param {Stirng} username  登录名
 * @param {Stirng} locked 是否锁定
 */
export const getMyUserListlocked = async (options) => {
  const { data: { recordCount, records } } = await axios.get(`v1/users/external?pageSize=${options.pageSize}&pageNo=${options.pageNo}&username=${options.username}&locked=true`)
  return { recordCount, records }
}

/**
 * 新增外部用户
 * @param {String} username 登录名
 * @param {String} nickname 昵称
 * @param {String} password 密码
 * @param {String} roleName 角色名
 * @param {Stirng} systemId 子系统ID（只有销售创建才是必选
 */
export const addMyUser = async (options) => {
  const { data: { success } } = await axios.post('v1/users/external', options)
  return success
}

/**
 * 重置密码
 * @param {String} userId 用户ID
 */
export const resetMyUserPassword = async (userId) => {
  const { data: { success, detail } } = await axios.post(`v1/users/external/${userId}/password/reset`)
  return { success, detail }
}

/**
 * 锁定用户
 * @param {String} userId 用户ID
 */
export const lockMyUser = async (userId) => {
  const { data: { success } } = await axios.post(`v1/users/external/${userId}/lock`)
  return success
}

/**
 * 解锁用户
 * @param {String} userId 用户ID
 */
export const unlockMyUser = async (userId) => {
  const { data: { success } } = await axios.post(`v1/users/external/${userId}/unlock`)
  return success
}

/**
 * 获取子系统信息
 */
export const getSystemId = async () => {
  const { data } = await axios.get(`v1/sub-systems`)
  return data
}

/**
 * 获取当前销售的SUB1的所有客户
 */
export const getSubUser = async () => {
  const { data } = await axios.get(`v1/users/external/sub1`)
  return data
}

/**
 * 帐号升级（子系统迁移）
 * @param {*String} id 目标用户id
 * @param {*String} systemId 目标子系统id
 * @param {String} roleName 角色名
 */
export const migrateSys = async (options) => {
  // const { id, systemId, roleName } = options
  const { data } = await axios.put(`v1/users/external/migrate-sys`, options)
  return data
}

/**
 * 获取所有角色为销售的用户
 */
export const getSales = async () => {
  const { data } = await axios.get(`v1/users/external/sale`)
  return data
}

/**
 * 获取所有角色为销售的用户
 * @param {*String} targetSaleId 目标销售id
 * @param {*String} customerIds 被移交客户id
 */
export const transfer = async (options) => {
  const { data } = await axios.put(`v1/users/external/hand-over`, options)
  return data
}

/**
 * 获取当前用户的所有子用户列表
 */
export const getMySubusers = async () => {
  const { data } = await axios.get(`v1/user-domain-relas/get-my-subusers`)
  return data
}

/**
 * 获取销售下的所有合作伙伴
 */
export const getPartnersList = async () => {
  const { data } = await axios.get(`v1/users/external/list-partners`)
  return data
}

/**
 * 将合作伙伴升级为经销商
 */
export const setPartnerToDealer = async (options) => {
  const { data } = await axios.put(`v1/users/external/partner-to-dealer?partnerId=${options.partnerId}`)
  return data
}

/**
 * 获取经销商下的子系统列表
 */
export const getDealerList = async (options) => {
  const { data } = await axios.get(`v1/sub-systems/list-dealer`)
  return data
}

/**
 * 根据子系统类型获取所有子系统列表
 */
export const getSubSystemList = async (options) => {
  const { data } = await axios.get(`v1/sub-systems/list-by-sub-system-type`)
  return data
}

/**
 * 根据用户名获取该用户下一级子用户列表
 */
export const getSub1ByUserName = async (userName) => {
  const { data } = await axios.get(`v1/user-domain-relas/list-sub1-by-username?username=${userName}`)
  return data
}
